import React from 'react';
import env from '@beam-australia/react-env';
import { MatomoProvider, createInstance } from '@jonkoops/matomo-tracker-react';
import getCookie from '@/utils/cookies';
import isAnalyticsEnabled from '@/auth/featureToggles';
import { trackingCookie } from '../constants';

const SiteTracking = ({ children }) => {
  const analyticsCookie = getCookie(trackingCookie.NAME);
  const urlBase = env('SITE_TRACKING_URL') || 'off';
  const siteId = env('SITE_TRACKING_ID') || 'off';

  const instance = createInstance({
    urlBase,
    siteId,
    disabled: !(analyticsCookie === 'true' && isAnalyticsEnabled()),
  });

  return (
    <MatomoProvider value={instance}>
      {children}
    </MatomoProvider>
  );
};

export default SiteTracking;
